import { useState, useEffect, useRef } from "react";
import { connectSupportWs, disconnectSupportWs } from "@/lib/supportWs";
import TabbedSections from "@/components/TabbedSections";
import { sectionsByGroup } from "@/config/sections";

// 오류 제보(/tickets) — 기존 CxSection을 최상위 영역으로 승격 (2026-08-21 IA 재편).
// Admin에서 분리한 이유: 고객 문의·오류 제보는 "운영 계정 관리"와 다른 업무 흐름.
// 실시간 WS 배지 로직도 AdminPage에서 그대로 가져옴.
const TABS = sectionsByGroup("tickets");

export default function TicketsPage() {
  const [cxUnread, setCxUnread] = useState(0);
  const activeTabRef = useRef(null);

  useEffect(() => {
    const onCxEvent = () => {
      if (activeTabRef.current !== "cx") setCxUnread((n) => n + 1);
    };
    window.addEventListener("novadb:cx-event", onCxEvent);
    connectSupportWs();
    return () => {
      window.removeEventListener("novadb:cx-event", onCxEvent);
      disconnectSupportWs();
    };
  }, []);

  function handleActiveTabChange(id) {
    activeTabRef.current = id;
    if (id === "cx") setCxUnread(0);
  }

  return (
    <TabbedSections
      tabs={TABS}
      badges={{ cx: cxUnread }}
      onActiveTabChange={handleActiveTabChange}
      hideTabs
    />
  );
}
